import { cn } from "@pineseed/gui/util";
import { TextWithTags } from "./text-with-tags";
import { Tag } from "@pineseed/gui/types";

interface MessageWithTagsProps {
  content: string;
  markdown?: boolean;
  className?: string;
  useTags: () => {
    parseTextWithTags: (text: string) => { 
      type: "text" | "valid-tag" | "invalid-tag" | "escaped-at"; content: string; tag?: Tag }[];
    extractTagNameForDisplay: (content: string) => string;
  };
}

export function MessageWithTags({
  content,
  markdown = false,
  className,
  useTags,
}: MessageWithTagsProps) {
  const classNames = cn(
    "rounded-lg p-2 text-foreground bg-secondary prose break-words whitespace-normal",
    // Add markdown-specific styling if markdown is enabled
    markdown && "prose-sm max-w-none",
    className,
  );

  // For now, we'll render as div with inline tags
  // TODO: If markdown is needed, we'd need to parse markdown first, then tags
  return (
    <div className={classNames}>
      <TextWithTags text={content} tagSize="sm" useTags={useTags} />
    </div>
  );
}
